<template>
  <div class="formulate-option-stepper">
    <div
      v-for="(option, index) in localOptions"
      :key="option.value"
      class="step-group"
      :class="{
        'last-step-group': index === localOptions.length - 1,
      }"
    >
      <div class="d-flex align-items-center">
        <button
          type="button"
          class="step-item"
          :class="{
            'step-item-active': context.model >= option.value,
            'step-item-inactive': isExceedMaxValue(option.value),
          }"
          @click="() => onOptionSelect(option)"
        >
          {{ option.value }}
        </button>

        <div
          v-if="index !== localOptions.length - 1"
          class="step-progress"
          :class="{
            'step-progress-inactive': isExceedMaxValue(option.value),
          }"
        >
          <div
            class="step-progress-bar"
            :style="{
              width: `${getOptionProgress(option)}%`,
            }"
          />
        </div>
      </div>

      <div class="d-flex">
        <p class="step-item-size text-center h5">
          {{ option.label }}
        </p>

        <div
          v-if="index !== localOptions.length - 1"
          class="step-progress-size"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OptionStepper',

  components: {},

  props: {
    context: {
      type: Object,
      required: true,
    },
    maxValue: {
      type: Number,
      default: null,
    },
    invalidOptionMessage: {
      type: String,
      default: 'Opção indisponível.',
    },
  },

  data() {
    return {
      optionMessage: {},
    }
  },

  computed: {
    getOptionProgress() {
      return option => {
        let result = Number(this.context.model)
        if (!result) {
          return 0
        }

        if (this.context.model > option.maxValue) {
          return 100
        }

        if (this.context.model < option.value) {
          return 0
        }

        let { maxValue } = option

        if (result > 0) {
          result -= option.value
          maxValue -= option.value
        }

        return 100 * (result / maxValue)
      }
    },

    model() {
      return this.context.model
    },

    /**
     * return
     *  [{
     *    label: string,
     *    value: number | string,
     *    maxValue: number | string
     *  }]
     */
    localOptions() {
      return this.context.options || []
    },
  },

  watch: {
    model() {},
  },

  methods: {
    isExceedMaxValue(value) {
      return typeof this.maxValue === 'number' && value >= this.maxValue
    },
    onOptionSelect(option) {
      this.context.setErrors([])
      if (this.isExceedMaxValue(option.value)) {
        this.context.setErrors([this.invalidOptionMessage])

        return
      }

      const value = Number(option.value) || null
      this.context.model = value
      this.$emit('input', value)
    },
  },
}
</script>

<style lang="scss">
$buttonSize: 65px;

.formulate-option-stepper {
  display: flex;
  justify-content: safe center; // "safe" é pro caso do input estar dentro de um div com scroll

  .step-item-size {
    min-width: $buttonSize;
  }
  .step-progress-size {
    width: 100%;
  }

  .step-group {
    display: flex;
    gap: 10px;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    min-width: 130px;
    max-width: 100px + $buttonSize;

    &.last-step-group {
      flex: 1;
      min-width: auto;
      max-width: fit-content;
    }

    .step-progress {
      height: 6px;
      width: 100%;
      background-color: rgba(var(--theme-color-rgb), 0.5);

      .step-progress-bar {
        height: 6px;
        background-color: rgb(var(--theme-color-rgb));
        transition: width 0.3s;
      }
    }

    .step-progress-inactive {
      background-color: rgba(100, 104, 108, 0.5);
    }

    .step-item {
      border-radius: 50%;
      min-width: $buttonSize;
      min-height: $buttonSize;
      color: var(--light);
      font-size: 18px;
      font-weight: bold;
      border: 2px solid var(--theme-color);
      background-color: rgba(var(--theme-color-rgb), 0.5) !important;
    }

    .step-item-active {
      background-color: var(--theme-color) !important;
    }

    .step-item-inactive {
      background-color: rgba(100, 104, 108, 0.5) !important;
      border: 2px solid rgb(100, 104, 108);
      cursor: not-allowed;
    }

    .step-item:focus {
      filter: brightness(0.8);
    }
  }
}
</style>
